import { Box, TextField, Typography, useMediaQuery, Select, MenuItem, ButtonGroup, Button } from '@mui/material';
import CustomDatePicker from '../../../../utils/CustomDatePicker';
import React, { useState, useEffect, useCallback } from 'react';
import useDebounce from '../../../../hooks/useDebounce';
import { useTheme } from '@mui/material/styles';
import Iconify from '../../../Iconify';
import '../../../../css/machines/machineContractFiltration.css';

const MachineContractFiltration = ({ displayMode, setDisplayMode, totalContracts, filtersEmpty, contractFilters, setContractfilters, fetchedContracts, filteredRecordCount, companies }) => {

    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));

    const [search, setSearch] = useState(contractFilters.debouncedSearch || '');
    const [showResponsiveFilter, setShowResponsiveFilter] = useState(false);

    const debouncedSearch = useDebounce(search, 1000);

    useEffect(() => {
        setContractfilters((prev) => ({ ...prev, debouncedSearch: debouncedSearch }));
    }, [debouncedSearch, setContractfilters]);

    const clearFilters = useCallback(() => {
        setContractfilters({
            ...contractFilters,
            debouncedSearch: '',
            company: '',
            date: null,
            auto_renew: null
        });
        setSearch('');
    }, [setContractfilters, setSearch, contractFilters]);

    return (
        <Box className="machineContractFiltration_main_box">
            <Box className="machineContractFiltration_search_display_box">
                {!isDesktop &&
                    <Iconify
                        className='machineContractFiltration_filter_icon'
                        icon={"cil:filter"}
                        backgroundColor={showResponsiveFilter ? '#182E45' : '#fffff'}
                        color={showResponsiveFilter ? '#ffffff' : '#201E1E'}
                        onClick={() => setShowResponsiveFilter(!showResponsiveFilter)}
                    />
                }
                {isDesktop &&
                    <Box className='contractFiltration_counts'>
                        <Box className='contractFiltration_search_clear_box'>
                            {isDesktop ?
                                <TextField
                                    size="small"
                                    value={search}
                                    placeholder='Rechercher'
                                    onChange={(e) => setSearch(e.target.value)}
                                    variant="outlined"
                                    className='machineContractFiltration_search_box'
                                    InputProps={{
                                        startAdornment: <Iconify icon="bx:bx-search" className='machineContractFiltration_search_icon' />,
                                        sx: {
                                            backgroundColor: '#fff',
                                            height: '36px',
                                            fontFamily: 'Mulish',
                                            color: '#201E1E',
                                            fontSize: '14px',
                                            fontWeight: 400,
                                        },
                                    }}
                                />
                                :
                                <Iconify
                                    className='machineContractFiltration_filter_icon'
                                    icon="cil:filter"
                                    backgroundColor={showResponsiveFilter ? '#182E45' : '#fffff'}
                                    color={showResponsiveFilter ? '#ffffff' : '#201E1E'}
                                    onClick={() => setShowResponsiveFilter(!showResponsiveFilter)}
                                />
                            }
                            <Typography className='machineContractFiltration_clearAll' onClick={clearFilters}>Re-initialiser</Typography>
                        </Box>
                    </Box>
                }
                <Box className='machineContractFiltration_displayMode_box'>
                    <Typography className='usersFiltration_total_number'>
                        {fetchedContracts} affichés
                        {!filtersEmpty && ` / ${filteredRecordCount} filtrés`}
                        {` / ${totalContracts} au total`}
                    </Typography>
                    <ButtonGroup variant="outlined" >
                        <Button
                            className={displayMode === 'grid' ? 'machineContractFiltration_options_selected_button' : 'machineContractFiltration_options_button'}
                            onClick={() => setDisplayMode('grid')}
                        >
                            <Iconify icon={"gg:menu-grid-r"} />
                        </Button>
                        <Button
                            className={displayMode === 'list' ? 'machineContractFiltration_options_selected_button' : 'machineContractFiltration_options_button'}
                            onClick={() => setDisplayMode('list')}
                        >
                            <Iconify icon={"ph:list"} />
                        </Button>
                    </ButtonGroup>
                </Box>
            </Box>
            <Box className='machineContractFiltration_search_display_box'>
                {(isDesktop || showResponsiveFilter) &&
                    <Box className='contractFiltration_select_box'>
                        {!isDesktop &&
                            <TextField
                                size="small"
                                value={search}
                                placeholder='Rechercher'
                                onChange={(e) => setSearch(e.target.value)}
                                variant="outlined"
                                className='machineContractFiltration_search_box'
                                InputProps={{
                                    startAdornment: <Iconify icon="bx:bx-search" className='usersFiltration_search_icon' />,
                                    sx: {
                                        backgroundColor: '#fff',
                                        height: '36px',
                                        fontFamily: 'Mulish',
                                        color: '#201E1E',
                                        fontSize: '14px',
                                        fontWeight: 400,
                                    },
                                }}
                            />
                        }
                        {displayMode === 'grid' &&
                            <Box className='contractFiltration_grid_filtration'>
                                <Select
                                    className='contractFiltration_select'
                                    size="small"
                                    value={contractFilters.company}
                                    onChange={(e) => setContractfilters({ ...contractFilters, company: e.target.value })}
                                    startAdornment={<Iconify icon="uil:building" className='contractFiltration_select_icon' />}
                                    displayEmpty
                                    renderValue={(selected) => {
                                        if (!selected) {
                                            return <span>Entreprise associé</span>;
                                        }
                                        return selected.name;
                                    }}
                                >
                                    <MenuItem className='invoiceFiltration_select_item' value="">Tout</MenuItem>
                                    {companies?.map((company) => (
                                        <MenuItem className='invoiceFiltration_select_item' value={company}>{company.name}</MenuItem>
                                    ))}
                                </Select>
                                <CustomDatePicker
                                    value={contractFilters.date}
                                    onChange={(newDate) => {
                                        setContractfilters({ ...contractFilters, date: newDate });
                                    }}
                                />
                                <ButtonGroup variant="outlined">
                                    <Button
                                        className={!contractFilters.auto_renew ? 'machineContractFiltration_options_selected_button' : 'machineContractFiltration_options_button'}
                                        onClick={() => setContractfilters({ ...contractFilters, auto_renew: null })}
                                    >
                                        Tout
                                    </Button>
                                    <Button
                                        className={contractFilters.auto_renew?.id === 'true' ? 'machineContractFiltration_options_selected_button' : 'machineContractFiltration_options_button'}
                                        onClick={() => setContractfilters({ ...contractFilters, auto_renew: { id: 'true' } })}
                                    >
                                        Automatique
                                    </Button>
                                    <Button
                                        className={contractFilters.auto_renew?.id === 'false' ? 'machineContractFiltration_options_selected_button' : 'machineContractFiltration_options_button'}
                                        onClick={() => setContractfilters({ ...contractFilters, auto_renew: { id: 'false' } })}
                                    >
                                        Non automatique
                                    </Button>
                                </ButtonGroup>
                            </Box>
                        }
                    </Box>
                }
            </Box>
        </Box>
    )
}

export default MachineContractFiltration
